export default __webpack_public_path__ + "static/media/sfondothesandbox.3b40c9d3.png";